import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ByPassGuardService {
  private _bypass = false;

  setBypass(value: boolean) {
    this._bypass = value;
  }

  shouldBypass(): boolean {
    const value = this._bypass;
    this._bypass = false; 
    return value;
  }
}
